import { GetStaticProps, NextPage } from 'next'
import { Layout } from '../components/layout/layout'
import { REVALIDATION_FREQUENCY } from '../constants/revalidation'
import { GlobalProps, withLayoutProps } from '../globals/layout'
import { Home, HomeProps } from '../templates/home'
import { HomepageQuery, HomepageQueryDocument, HomepageQueryVariables } from '@gql'
import { pageQuery } from '../utils/pageQuery'

export type HomepageProps = GlobalProps & {
  data: HomeProps
}

const Homepage: NextPage<HomepageProps> = ({ data, ...layoutProps }) => {
  return (
    <Layout { ...layoutProps }>
      <Home { ...data } />
    </Layout>
  )
}

export default Homepage

export const getStaticProps: GetStaticProps = async (context) => {
  const { data } = await pageQuery<HomepageQuery, HomepageQueryVariables>({
    query: HomepageQueryDocument,
  }, context)

  return withLayoutProps({
    path: '/',
  }, data ? {
    props: { data },
    revalidate: REVALIDATION_FREQUENCY,
  } : {
    notFound: true,
  })
}
